

/**
 * Creates a shallow clone of the given object, preserving its prototype and property descriptors.
 * @param obj The object to clone.
 * @returns A shallow clone of the object.
 */
export function shallowCloneObject<T extends object>(obj: T): T {
    const clone = Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
    Object.assign(clone, obj);
    return clone;
}